// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SzE3V","label":"styles_label__1Yhy3"};